<div class="custom-datalist" *ngIf="!!options.dataList && options.dataList.length > 0 && !options.itemChosen" [attr.id]="uniqueId">
  <ul class="list-group" *ngIf="!!shownData && shownData.length > 0 && (options.showOnHighlight || (!!options.searchValue && options.searchValue.length > 0))">
    <li class="list-group-item" *ngFor="let x of shownData" (click)="itemSelected(x)">
      <button class="btn btn-square mr-2" [style.backgroundColor]="findColor('b', x[options.shownValue])" [style.color]="findColor('c', x[options.shownValue])" *ngIf="options.icon">
        {{ user.getInitials(x[options.shownValue]) }}
      </button>
      <!-- Display when shownData is not an array and not badge -->
      <div *ngIf="!shownDataIsArray && !options.badge" style="width: calc(100% - 1.3rem);">
        <span class="d-block ellipsis">{{ x[options.shownValue] }}</span>
      </div>
      <!-- Display when shownData is not an array and badge-->
      <div *ngIf="!shownDataIsArray && options.badge">
        <span class="badge ellipsis" [style.backgroundColor]="findBadgeColor('b', x)" [style.color]="findBadgeColor('t', x)">{{ x[options.shownValue] }}</span>
      </div>
      <div *ngIf="shownDataIsArray">
        <!-- Display when shownData is an array -->
        <div *ngIf="!!shownValueArray">
          <span class="mr-2" *ngFor="let i of shownValueArray">{{ x[i] }}</span>
        </div>
      </div>
    </li>
  </ul>
</div>
